/**
 * localStorage flag set once the user finishes or skips onboarding.
 * Its own module, free of React, so the e2e harness can import it.
 */
export const ONBOARDING_DONE_KEY = "omni:onboarding-v1";
